import type { Icon } from '../../../src/lib/types'
export const mdiInformation: Icon = {
  "id": "information",
  "name": "Information",
  "path": "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z",
  "as": [
    "about",
    "information-circle",
    "info-circle",
    "about-circle"
  ],
  "tags": []
}
export default mdiInformation